/** Breakpoints' minimum widths in rem, matching _responsive.less. */
export const breakpointWidths = { tabletUp: 43.75, desktopUp: 62.5 } as const;

export const breakpointMediaQueries = {
    tabletUp: `(min-width: ${breakpointWidths.tabletUp}rem)`,
    desktopUp: `(min-width: ${breakpointWidths.desktopUp}rem)`,
} as const;

export type BreakpointName = keyof typeof breakpointMediaQueries;

export function matchesBreakpoint(query: BreakpointName): boolean {
    return window.matchMedia(breakpointMediaQueries[query]).matches;
}

export function isTabletUp(): boolean {
    return matchesBreakpoint('tabletUp');
}

export function isDesktopUp(): boolean {
    return matchesBreakpoint('desktopUp');
}

/** Whether the main pointer can hover. A mouse can, but a finger can't. */
export function canHover(): boolean {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}
